
export const easterEggAssets = [
	{ 
		url: 'hpztxj',
	},
	// { 
	// 	url: 't6xbbc',
	// },
	// { 
	// 	url: 'ujkl3b',
	// },
];

// export const starshipAssets = [
// 	{ 
// 		id: 'yoshi',
// 		image: 'mk4sjc.webp',
// 		easterEggNum: 1
// 	},
// 	{ 
// 	 	id: 'arwing',
// 	 	image: 'dj39xd.png',
// 	 	easterEggNum: 2
// 	},
// ];

